import { useMutation } from '@apollo/client/react'

import { toast } from '@buffer-mono/popcorn'
import { UploadType } from '@buffer-mono/uploader'

import { useAccount } from '~publish/contexts/AccountContext'
import { graphql } from '~publish/graphql'

import { PhotoUploader } from '../../shared/components/PhotoUploader'

import type { JSX } from 'react'

export const UPDATE_ACCOUNT_AVATAR = graphql(/* GraphQL */ `
  mutation UpdateAccountAvatar($input: UpdateAccountAvatarInput!) {
    updateAccountAvatar(input: $input) {
      __typename
      ... on UpdateAccountAvatarSuccess {
        _empty
      }
      ... on UnexpectedError {
        message
      }
      ... on InvalidInputError {
        message
      }
      ... on NotFoundError {
        message
      }
    }
  }
`)

const Photo = (): JSX.Element => {
  const { account, refetchAccount } = useAccount()
  const [updateAccountAvatar] = useMutation(UPDATE_ACCOUNT_AVATAR)

  const handleUploadComplete = async (url: string): Promise<void> => {
    const result = await updateAccountAvatar({
      variables: { input: { url } },
    })

    if (
      result.data?.updateAccountAvatar?.__typename !==
      'UpdateAccountAvatarSuccess'
    ) {
      throw new Error(
        'We had trouble updating your account photo. Please try again.',
      )
    }

    void refetchAccount?.()
    toast.success('Your account photo has been updated!')
  }

  return (
    <PhotoUploader
      src={account?.avatar ?? undefined}
      alt="Account photo"
      label="Photo"
      description="Please choose a photo that is at least 180x180 pixels in size."
      uploadType={UploadType.accountAvatar}
      cropSize={200}
      onUploadComplete={handleUploadComplete}
      uploadErrorMessage="Photo upload failed. Please try again."
    />
  )
}

export default Photo
